export default function EditIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 7.58578L16.5858 6H18V7.41421L16.4142 8.99999L15 7.58578ZM13.5858 8.99999L6 16.5858V17.9999L6.00005 18H7.41419L15 10.4142L13.5858 8.99999Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
